<div class="health d-flex align-items-center">
  <div class="d-flex align-items-center wrap p-1">
    <app-generic-score-strength
      title="{{ pingLatency }}"
      description="{{ descriptionPingLatency }}"
      [maximumMs]="healthSettings.pingMaxDelay"
      [averageLength]="healthSettings.measurePoolLength"
      [score]="health.pingScore"
      [value]="health.pingDelay"
      [showValue]="true"
      icon="network"
    ></app-generic-score-strength>
    <!-- <app-generic-score-strength
      title="Heartbeat Mahvis"
      description="Time difference between two receptions.
      Indicates that the Mahvis algo is awake.
      "
      [maximumMs]="healthSettings.stateRefreshHeartbeatMaxPeriod"
      [averageLength]="healthSettings.measurePoolLength"
      [score]="health.heartbeatScore"
      [value]="health.stateRefreshHeartbeatDelay"
      [showValue]="true"
      icon="network"
    ></app-generic-score-strength> -->
    <app-generic-score-strength
      title="{{ stateUpdateBfs }}"
      description="{{ descriptionStateUpdateBfs }}"
      [maximumMs]="healthSettings.stateUpdateDateMaxDelay"
      [averageLength]="healthSettings.measurePoolLength"
      [score]="health.stateUpdateScore"
      [value]="health.stateUpdateDateDelay"
      [showValue]="true"
      icon="network"
    ></app-generic-score-strength>
    <app-generic-score-strength
      title="{{ timeShift }}"
      description="{{ descriptionTimeShift }}"
      [maximumMs]="healthSettings.timeshiftMaxDelay"
      [averageLength]="healthSettings.measurePoolLength"
      [score]="health.timeshiftScore"
      [value]="health.timeshift"
      [showValue]="true"
      icon="network"
    ></app-generic-score-strength>
    <app-generic-score-strength
      title="{{ dateOffset }}"
      description="{{ descriptionDateOffset }}"
      [score]=""
      [value]="health.dateOffset"
      [showValue]="true"
      [scoreBoolean]="health.dateOffsetIndicator"
      icon="circle"
    ></app-generic-score-strength>
  </div>
</div>
